import styled from 'styled-components';
import StyledModal from '../Modal/styled';

export default {
  Wrapper: styled.div`
    ${StyledModal.Container} {
      padding: 24px;
    }
  `,

  Title: styled.div`
    padding-right: 18px;
    margin-bottom: 24px;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    color: #000000;
  `,

  Container: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 20px;
    line-height: 26px;
    color: #000000;
  `,

  ItemPrice: styled.div``,

  Footer: styled.div`
    margin: 24px -24px -24px;
    padding: 14px 24px;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 0px 0px 8px 8px;
  `,

  Price: styled.span`
    margin-left: 8px;
    font-weight: bold;
    font-size: 16px;
  `,
};
